import type { TransKeys } from '@/i18n/trans/index';
import { createTrans } from '@/i18n/trans/index';
import { Trans } from 'react-i18next';

export const TransText = createTrans({
  MODIFICATION_FEE: (
    <Trans i18nKey="text.MODIFICATION_FEE" defaults="Change fee" />
  ),
  PAYMENT_METHOD_FEE: (
    <Trans i18nKey="text.PAYMENT_METHOD_FEE" defaults="Payment method fee" />
  ),
  PLACE_SELECTION_FEE: (
    <Trans i18nKey="text.PLACE_SELECTION_FEE" defaults="Seat selection fee" />
  ),
  RETURN_FEE: <Trans i18nKey="text.RETURN_FEE" defaults="Refund fee" />,
  SALES_FEE: <Trans i18nKey="text.SALES_FEE" defaults="Booking fee" />,
  SEAT_SELECTION_FEE: (
    <Trans i18nKey="text.SEAT_SELECTION_FEE" defaults="Reservation" />
  ),
  account: <Trans i18nKey="text.account" defaults="Account" />,
  accountCreated: (
    <Trans i18nKey="text.accountCreated" defaults="Account created!" />
  ),
  accountDetails: (
    <Trans i18nKey="text.accountDetails" defaults="Account details" />
  ),
  accountSettings: (
    <Trans i18nKey="text.accountSettings" defaults="Account settings" />
  ),
  activation: <Trans i18nKey="text.activation" defaults="Activation" />,
  active: <Trans i18nKey="text.active" defaults="Active" />,
  addEmailAddress: (
    <Trans i18nKey="text.addEmailAddress" defaults="Add email address" />
  ),
  addExtras: <Trans i18nKey="text.addExtras" defaults="Add extras" />,
  addMoreEmails: (
    <Trans i18nKey="text.addMoreEmails" defaults="Add more emails" />
  ),
  addNewVoucherCode: (
    <Trans i18nKey="text.addNewVoucherCode" defaults="Add new voucher code" />
  ),
  addToWallet: <Trans i18nKey="text.addToWallet" defaults="Add to wallet" />,
  addVoucher: <Trans i18nKey="text.addVoucher" defaults="Add voucher" />,
  addedExtras: <Trans i18nKey="text.addedExtras" defaults="Added extras" />,
  additionalFees: (
    <Trans i18nKey="text.additionalFees" defaults="Additional fees" />
  ),

  allTickets: <Trans i18nKey="text.allTickets" defaults="All tickets" />,
  allTicketsCount: (
    <Trans
      i18nKey="text.allTicketsCount"
      defaults="(1)[All tickets sent to {{count}} recipient];(2-inf)[All tickets sent to {{count}} recipients];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  alreadyHaveAnAccount: (
    <Trans
      i18nKey="text.alreadyHaveAnAccount"
      defaults="Already have an account?"
    />
  ),
  appliedCode: <Trans i18nKey="text.appliedCode" defaults="Applied code" />,
  appliedVouchers: (
    <Trans i18nKey="text.appliedVouchers" defaults="Applied vouchers" />
  ),
  apply: <Trans i18nKey="text.apply" defaults="Apply" />,
  areYouSureYouWantToCancelThePurchase: (
    <Trans
      i18nKey="text.areYouSureYouWantToCancelThePurchase"
      defaults="Are you sure you want to cancel the purchase?"
    />
  ),
  arrival: <Trans i18nKey="text.arrival" defaults="Arrival" />,
  available: <Trans i18nKey="text.available" defaults="Available" />,
  availableSeat: (
    <Trans i18nKey="text.availableSeat" defaults="Available seat" />
  ),
  back: <Trans i18nKey="text.back" defaults="Back" />,
  backToBooking: (
    <Trans i18nKey="text.backToBooking" defaults="Back to booking" />
  ),
  backToJourneySearch: (
    <Trans
      i18nKey="text.backToJourneySearch"
      defaults="Back to the journey search"
    />
  ),
  birthDate: <Trans i18nKey="text.birthDate" defaults="Date of birth" />,
  bookedTravelPasses: (
    <Trans i18nKey="text.bookedTravelPasses" defaults="Booked travel passes" />
  ),
  booking: <Trans i18nKey="text.booking" defaults="Booking" />,
  bookingItems: <Trans i18nKey="text.bookingItems" defaults="Booking items" />,
  bookingNo: (
    <Trans
      i18nKey="text.bookingNo"
      defaults="Your booking number is: {{number}}"
    />
  ),
  bookingNumber: (
    <Trans i18nKey="text.bookingNumber" defaults="Booking number" />
  ),
  bookingSessionExpired: (
    <Trans
      i18nKey="text.bookingSessionExpired"
      defaults="Booking session expired"
    />
  ),
  bookingSessionExpiresIn: (
    <Trans
      i18nKey="text.bookingSessionExpiresIn"
      defaults="Booking session expires in"
    />
  ),
  bookingSessionExpiryDescription: (
    <Trans
      i18nKey="text.bookingSessionExpiryDescription"
      defaults="Your booking session has expired. Start a new session to resume the booking process."
    />
  ),
  bookingSummary: (
    <Trans i18nKey="text.bookingSummary" defaults="Booking summary" />
  ),
  bookingTotal: <Trans i18nKey="text.bookingTotal" defaults="Booking total" />,
  bus: <Trans i18nKey="text.bus" defaults="Bus" />,
  cancel: <Trans i18nKey="text.cancel" defaults="Cancel" />,
  cancelChange: <Trans i18nKey="text.cancelChange" defaults="Cancel" />,
  cancelChangeConfirmation: (
    <Trans
      i18nKey="text.cancelChangeConfirmation"
      defaults="Are you sure you want to cancel this booking modification?"
    />
  ),
  cancelPurchase: (
    <Trans i18nKey="text.cancelPurchase" defaults="Cancel purchase" />
  ),
  cancelled: <Trans i18nKey="text.cancelled" defaults="Cancelled" />,
  changePassword: (
    <Trans i18nKey="text.changePassword" defaults="Change password" />
  ),
  changeSessionExpired: (
    <Trans
      i18nKey="text.changeSessionExpired"
      defaults="Modification session expired"
    />
  ),
  changeSessionExpiryDescription: (
    <Trans
      i18nKey="text.changeSessionExpiryDescription"
      defaults="Your booking modification session has expired. Please start the change again from your booking."
    />
  ),
  changeTotal: <Trans i18nKey="text.changeTotal" defaults="Change total" />,
  changeTrips: <Trans i18nKey="text.changeTrips" defaults="Change trips" />,
  changeTripsHeading: (
    <Trans
      i18nKey="text.changeTripsHeading"
      defaults="Change trips: {{bookingCode}}"
    />
  ),
  changeable: <Trans i18nKey="text.changeable" defaults="Changeable" />,
  changedSeat: <Trans i18nKey="text.changedSeat" defaults="Changed seat" />,
  checkYourEmail: (
    <Trans i18nKey="text.checkYourEmail" defaults="Check your email" />
  ),
  checkout: <Trans i18nKey="text.checkout" defaults="Checkout" />,
  chooseTravelPassesToRefund: (
    <Trans
      i18nKey="text.chooseTravelPassesToRefund"
      defaults="Choose travel pass(es) to refund"
    />
  ),
  chooseTripsToRefund: (
    <Trans
      i18nKey="text.chooseTripsToRefund"
      defaults="Choose trips to refund"
    />
  ),
  close: <Trans i18nKey="text.close" defaults="Close" />,
  coTravelerSeat: (
    <Trans i18nKey="text.coTravelerSeat" defaults="Co-traveller's seat" />
  ),
  compensation: <Trans i18nKey="text.compensation" defaults="Compensation" />,
  conflictingTrips: (
    <Trans i18nKey="text.conflictingTrips" defaults="Conflicting trips" />
  ),
  conflictingTripsDescription: (
    <Trans
      i18nKey="text.conflictingTripsDescription"
      defaults="Trip change has to be done separately for selected trips because passengers travel on different trips."
    />
  ),
  conflictingTripsHint: (
    <Trans
      i18nKey="text.conflictingTripsHint"
      defaults="Please check that selected trips include the same passengers."
    />
  ),
  confirm: <Trans i18nKey="text.confirm" defaults="Confirm" />,
  consents: <Trans i18nKey="text.consents" defaults="Consents" />,
  confirmRegistration: (
    <Trans i18nKey="text.confirmRegistration" defaults="Confirm registration" />
  ),
  confirmRegistrationDescription: (
    <Trans
      i18nKey="text.confirmRegistrationDescription"
      defaults="We have sent you a verification email. To continue, please click on the verification link provided in that email. If you haven't received it, please check your spam folder or click on the resend link below."
    />
  ),
  continue: <Trans i18nKey="text.continue" defaults="Continue" />,
  continueToCheckout: (
    <Trans i18nKey="text.continueToCheckout" defaults="Continue to checkout" />
  ),
  country: <Trans i18nKey="text.country" defaults="Country" />,
  nationality: <Trans i18nKey="text.nationality" defaults="Nationality" />,
  continueWithEmail: (
    <Trans i18nKey="text.continueWithEmail" defaults="Continue with email" />
  ),
  createAPassword: (
    <Trans i18nKey="text.createAPassword" defaults="Create a password" />
  ),
  createAnAccount: (
    <Trans i18nKey="text.createAnAccount" defaults="Create an account" />
  ),
  createNewPassword: (
    <Trans i18nKey="text.createNewPassword" defaults="Create new password" />
  ),
  currentTrip: <Trans i18nKey="text.currentTrip" defaults="Current trip" />,
  custom: <Trans i18nKey="text.custom" defaults="custom" />,
  deckIndex: <Trans i18nKey="text.deckIndex" defaults="Deck {{index}}" />,
  deleteAccount: (
    <Trans i18nKey="text.deleteAccount" defaults="Delete account" />
  ),
  deleteAccountDescription: (
    <Trans
      i18nKey="text.deleteAccountDescription"
      defaults="All associated data will be permanently removed. This action cannot be undone, and you will lose access to any saved information or settings."
    />
  ),
  deleteAccountModalDescription: (
    <Trans
      i18nKey="text.deleteAccountModalDescription"
      defaults="All the account related data will be deleted permanently. Are you sure you want to delete your account?"
    />
  ),
  destinationStop: (
    <Trans i18nKey="text.destinationStop" defaults="Destination" />
  ),
  permanentlyDeleteAccount: (
    <Trans
      i18nKey="text.permanentlyDeleteAccount"
      defaults="Permanently delete account"
    />
  ),
  permanentlyDeleteAccountConfirm: (
    <Trans
      i18nKey="text.permanentlyDeleteAccountConfirm"
      defaults="Permanently delete account?"
    />
  ),
  deleteSeatChangeDescription: (
    <Trans
      i18nKey="text.deleteSeatChangeDescription"
      defaults="Are you sure you want to remove selected seat? You will be automatically assigned a new seat, which may be different than your original seat."
    />
  ),
  deleteSeatChangeTitle: (
    <Trans
      i18nKey="text.deleteSeatChangeTitle"
      defaults="Remove selected seat"
    />
  ),

  departure: <Trans i18nKey="text.departure" defaults="Departure" />,
  details: <Trans i18nKey="text.details" defaults="Details" />,
  direct: <Trans i18nKey="text.direct" defaults="Direct" />,
  discount: <Trans i18nKey="text.discount" defaults="Discount" />,
  dismiss: <Trans i18nKey="text.dismiss" defaults="Dismiss" />,
  dismissWarning: (
    <Trans i18nKey="text.dismissWarning" defaults="Dismiss warning" />
  ),
  doesntMatchCriteriaDescribedAbove: (
    <Trans
      i18nKey="text.doesntMatchCriteriaDescribedAbove"
      defaults="Doesn't match the criteria described above"
    />
  ),
  done: <Trans i18nKey="text.done" defaults="Done" />,
  download: <Trans i18nKey="text.download" defaults="Download" />,
  downloadTickets: (
    <Trans i18nKey="text.downloadTickets" defaults="Download tickets" />
  ),
  editPassengerDetails: (
    <Trans
      i18nKey="text.editPassengerDetails"
      defaults="Edit passenger details"
    />
  ),
  editPassengerDetailsError: (
    <Trans
      i18nKey="text.editPassengerDetailsError"
      defaults="Failed to update passenger details"
    />
  ),
  editPassengerDetailsSuccess: (
    <Trans
      i18nKey="text.editPassengerDetailsSuccess"
      defaults="Passenger details successfully changed."
    />
  ),
  editSearch: <Trans i18nKey="text.editSearch" defaults="Edit search" />,
  email: <Trans i18nKey="text.email" defaults="Email" />,
  emailToSendAllTicketsTo: (
    <Trans
      i18nKey="text.emailToSendAllTicketsTo"
      defaults="Email number {{count}} to send all tickets to"
    />
  ),
  emailUsedForBooking: (
    <Trans
      i18nKey="text.emailUsedForBooking"
      defaults="Email (used for booking)"
    />
  ),
  emailsCount: (
    <Trans
      i18nKey="emailsCount"
      defaults="(0)[{{count}} emails];(1)[{{count}} email];(2-inf)[{{count}} emails];"
      tOptions={{
        postProcess: 'interval',
      }}
    />
  ),
  enterVoucherCode: (
    <Trans i18nKey="text.enterVoucherCode" defaults="Enter voucher code..." />
  ),
  enterYourBookingNumber: (
    <Trans
      i18nKey="text.enterYourBookingNumber"
      defaults="Enter your booking number"
    />
  ),
  enterYourEmailAddress: (
    <Trans
      i18nKey="text.enterYourEmailAddress"
      defaults="Enter your email address"
    />
  ),
  enterYourPassword: (
    <Trans i18nKey="text.enterYourPassword" defaults="Enter your password" />
  ),
  errorDownloadingPkpass: (
    <Trans
      i18nKey="text.errorDownloadingPkpass"
      defaults="Failed to download pkpass"
    />
  ),
  errorFetchingActiveTickets: (
    <Trans
      i18nKey="text.errorFetchingActiveTickets"
      defaults="Failed to fetch active tickets"
    />
  ),
  errorFetchingActiveTravelPasses: (
    <Trans
      i18nKey="text.errorFetchingActiveTravelPasses"
      defaults="Failed to fetch active travel passes"
    />
  ),
  errorFetchingActiveVouchers: (
    <Trans
      i18nKey="text.errorFetchingActiveVouchers"
      defaults="Failed to load active vouchers"
    />
  ),
  errorFetchingHistoryTickets: (
    <Trans
      i18nKey="text.errorFetchingHistoryTickets"
      defaults="Failed to fetch history tickets"
    />
  ),
  errorFetchingHistoryTravelPasses: (
    <Trans
      i18nKey="text.errorFetchingHistoryTravelPasses"
      defaults="Failed to fetch history travel passes"
    />
  ),
  errorFetchingHistoryVouchers: (
    <Trans
      i18nKey="text.errorFetchingHistoryVouchers"
      defaults="Failed to load voucher history"
    />
  ),
  errorSendingEmail: (
    <Trans
      i18nKey="text.errorSendingEmail"
      defaults="Confirmation email not sent"
    />
  ),
  exchanged: <Trans i18nKey="text.exchanged" defaults="Exchanged" />,
  exempliGratia: <Trans i18nKey="text.exempliGratia" defaults="e.g." />,
  expiryDate: <Trans i18nKey="text.expiryDate" defaults="Expiry date" />,
  externalPay: <Trans i18nKey="text.externalPay" defaults="Pay (external)" />,
  extras: <Trans i18nKey="text.extras" defaults="Extras" />,
  failedToCreateAccount: (
    <Trans
      i18nKey="text.failedToCreateAccount"
      defaults="Failed to create account."
    />
  ),
  failedToCreateBooking: (
    <Trans
      i18nKey="text.failedToCreateBooking"
      defaults="Failed to create booking."
    />
  ),
  failedToLoadSeatSelectionModal: (
    <Trans
      i18nKey="text.failedToLoadSeatSelectionModal"
      defaults="Loading seat selection modal failed."
    />
  ),
  female: <Trans i18nKey="text.female" defaults="Female" />,
  fillOutFollowingRegistrationForm: (
    <Trans
      i18nKey="text.fillOutFollowingRegistrationForm"
      defaults="Please fill out the following registration form to sign up with us."
    />
  ),
  fillWithDataFrom: (
    <Trans i18nKey="text.fillWithDataFrom" defaults="Fill with data from" />
  ),
  findYourBooking: (
    <Trans i18nKey="text.findYourBooking" defaults="Find your booking" />
  ),
  firstName: <Trans i18nKey="text.firstName" defaults="First name" />,
  forgotPassword: (
    <Trans i18nKey="text.forgotPassword" defaults="Forgot password" />
  ),
  free: <Trans i18nKey="text.free" defaults="Free" />,
  from: <Trans i18nKey="text.from" defaults="From" />,
  front: <Trans i18nKey="text.front" defaults="Front" />,
  gender: <Trans i18nKey="text.gender" defaults="Gender" />,
  giftCard: <Trans i18nKey="text.giftCard" defaults="Gift card" />,
  gladToHaveYouOnBoard: (
    <Trans
      i18nKey="text.gladToHaveYouOnBoard"
      defaults="Glad to have you on board!"
    />
  ),
  goBack: <Trans i18nKey="text.goBack" defaults="Go back" />,
  hello: <Trans i18nKey="text.hello" defaults="Hello!" />,
  helloDisplayName: (
    <Trans i18nKey="text.helloDisplayName" defaults="Hello, {{displayName}}" />
  ),
  history: <Trans i18nKey="text.history" defaults="History" />,
  importantInformation: (
    <Trans
      i18nKey="text.importantInformation"
      defaults="Important information"
    />
  ),
  insertCurrentPassword: (
    <Trans
      i18nKey="text.insertCurrentPassword"
      defaults="Insert current password"
    />
  ),
  insertYourEmail: (
    <Trans i18nKey="text.insertYourEmail" defaults="Insert your email" />
  ),
  intermediateStop: (
    <Trans i18nKey="text.intermediateStop" defaults="Intermediate stop" />
  ),
  invalidEmail: (
    <Trans i18nKey="text.invalidEmail" defaults="Invalid email address" />
  ),
  invalidEmailFormat: (
    <Trans i18nKey="text.invalidEmailFormat" defaults="Invalid email format" />
  ),
  invalidPhoneNumberFormat: (
    <Trans
      i18nKey="text.invalidPhoneNumberFormat"
      defaults="Invalid phone number format"
    />
  ),
  journeyMap: <Trans i18nKey="text.journeyMap" defaults="Journey map" />,
  journeyTransfersCount: (
    <Trans
      i18nKey="text.journeyTransfersCount"
      defaults="(0)[{{count}} transfers];(1)[{{count}} transfer];(2-inf)[{{count}} transfers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  lastName: <Trans i18nKey="text.lastName" defaults="Last name" />,
  leg: <Trans i18nKey="text.leg" defaults="Leg" />,
  legs: <Trans i18nKey="text.legs" defaults="Legs" />,
  loading: <Trans i18nKey="text.loading" defaults="Loading..." />,
  logIn: <Trans i18nKey="text.logIn" defaults="Log in" />,
  logInWithEmailAndPassword: (
    <Trans
      i18nKey="text.logInWithEmailAndPassword"
      defaults="Log in with email and password"
    />
  ),
  loginDetails: <Trans i18nKey="text.loginDetails" defaults="Login details" />,
  logOut: <Trans i18nKey="text.logOut" defaults="Log out" />,
  loginFailed: <Trans i18nKey="text.loginFailed" defaults="Login failed" />,
  loyalty: <Trans i18nKey="text.loyalty" defaults="Loyalty" />,
  makeChanges: <Trans i18nKey="text.makeChanges" defaults="Make changes" />,
  male: <Trans i18nKey="text.male" defaults="Male" />,
  manageBooking: (
    <Trans i18nKey="text.manageBooking" defaults="Manage booking" />
  ),
  maximum64: (
    <Trans
      i18nKey="text.maximum64"
      defaults="Can not be more than 64 characters long"
    />
  ),
  minimumEight: (
    <Trans
      i18nKey="text.minimumEight"
      defaults="Must be at least 8 characters long"
    />
  ),
  minimumOne: (
    <Trans i18nKey="text.minimumOne" defaults="Must choose at least one" />
  ),
  minutesCount: (
    <Trans
      i18nKey="text.minutesCount"
      defaults="(0)[{{count}} minutes];(1)[{{count}} minute];(2-inf)[{{count}} minutes];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  missingEmail: <Trans i18nKey="text.missingEmail" defaults="Missing email" />,
  mustAddEmailToEveryRecipient: (
    <Trans
      i18nKey="text.mustAddEmailToEveryRecipient"
      defaults="You must add email to every recipient"
    />
  ),
  mustBeFilled: <Trans i18nKey="text.mustBeFilled" defaults="Must be filled" />,
  mustChooseLeg: (
    <Trans i18nKey="text.mustChooseLeg" defaults="You must choose a leg" />
  ),
  myInformation: (
    <Trans i18nKey="text.myInformation" defaults="My information" />
  ),
  new: <Trans i18nKey="text.new" defaults="New" />,
  next: <Trans i18nKey="text.next" defaults="Next" />,
  nextAvailableDates: (
    <Trans
      i18nKey="text.nextAvailableDates"
      defaults="Next available dates: {{departureDate}} - {{returnDate}}"
    />
  ),
  nextAvailableDepartureDate: (
    <Trans
      i18nKey="text.nextAvailableDepartureDate"
      defaults="Next available departure date: {{date}}"
    />
  ),
  nextAvailableReturnDate: (
    <Trans
      i18nKey="text.nextAvailableReturnDate"
      defaults="Next available return date: {{date}}"
    />
  ),
  noActiveTravelPasses: (
    <Trans
      i18nKey="text.noActiveTravelPasses"
      defaults="No active travel passes"
    />
  ),
  noActiveVouchers: (
    <Trans i18nKey="text.noActiveVouchers" defaults="No active vouchers" />
  ),
  noConsumptionsFound: (
    <Trans
      i18nKey="text.noConsumptionsFound"
      defaults="No trips have been booked with this travel pass yet"
    />
  ),
  noCountryFound: (
    <Trans i18nKey="text.noCountryFound" defaults="No country found" />
  ),
  noExtrasAdded: (
    <Trans i18nKey="text.noExtrasAdded" defaults="No extras added" />
  ),
  noExtrasAvailable: (
    <Trans i18nKey="text.noExtrasAvailable" defaults="No extras available" />
  ),
  noHistoryTickets: (
    <Trans i18nKey="text.noHistoryTickets" defaults="No history of tickets" />
  ),
  noHistoryTravelPasses: (
    <Trans
      i18nKey="text.noHistoryTravelPasses"
      defaults="No history of travel passes"
    />
  ),
  noHistoryVouchers: (
    <Trans i18nKey="text.noHistoryVouchers" defaults="No history of vouchers" />
  ),
  noSeatSelectionAvailable: (
    <Trans
      i18nKey="text.noSeatSelectionAvailable"
      defaults="No seat selection available"
    />
  ),
  noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain: (
    <Trans
      i18nKey="text.noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain"
      defaults="No travel passes found. Please change the search inputs and try again."
    />
  ),
  noTripsFoundPleaseChangeSearchInputsAndTryAgain: (
    <Trans
      i18nKey="text.noTripsFoundPleaseChangeSearchInputsAndTryAgain"
      defaults="No trips found. Please change the search inputs and try again."
    />
  ),
  noUpcomingTickets: (
    <Trans i18nKey="text.noUpcomingTickets" defaults="No upcoming tickets" />
  ),
  noVouchersApplied: (
    <Trans i18nKey="text.noVouchersApplied" defaults="No vouchers applied" />
  ),
  nonRefundable: (
    <Trans i18nKey="text.nonRefundable" defaults="Non-refundable" />
  ),
  notAvailable: <Trans i18nKey="text.notAvailable" defaults="Not available" />,
  notRegisteredYet: (
    <Trans i18nKey="text.notRegisteredYet" defaults="Not registered yet?" />
  ),
  optional: <Trans i18nKey="text.optional" defaults="optional" />,
  optionalData: <Trans i18nKey="text.optionalData" defaults="Optional data" />,
  other: <Trans i18nKey="text.other" defaults="Other" />,
  originStop: <Trans i18nKey="text.originStop" defaults="Origin" />,
  originalExtrasNotChangedNotice: (
    <Trans
      i18nKey="text.originalExtrasNotChangedNotice"
      defaults="The extras from your original booking aren't carried over — add the ones you want for this changed trip."
    />
  ),
  originalValue: (
    <Trans i18nKey="text.originalValue" defaults="Original value" />
  ),
  outbound: <Trans i18nKey="text.outbound" defaults="Outbound" />,
  outboundTrip: <Trans i18nKey="text.outboundTrip" defaults="Outbound trip" />,
  outboundTrips: (
    <Trans
      i18nKey="text.outboundTrips"
      defaults="(0)[Outbound trips];(1)[Outbound trip];(2-inf)[Outbound trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  partiallyCancelled: (
    <Trans i18nKey="text.partiallyCancelled" defaults="Partially cancelled" />
  ),
  partiallyRefunded: (
    <Trans i18nKey="text.partiallyRefunded" defaults="Partially refunded" />
  ),
  passenger: <Trans i18nKey="text.passenger" defaults="Passenger" />,
  passengerIndex: (
    <Trans
      i18nKey="text.passengerIndex"
      defaults="(0)[Passenger];(1-inf)[Passenger {{count}}];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  passengerXEmailY: (
    <Trans
      i18nKey="text.passengerXEmailY"
      defaults="Passenger {{passengerCount}} email {{emailCount}}"
    />
  ),
  passengers: <Trans i18nKey="text.passengers" defaults="Passengers" />,
  passengersCount: (
    <Trans
      i18nKey="text.passengersCount"
      defaults="(0)[{{count}} passengers];(1)[{{count}} passenger];(2-inf)[{{count}} passengers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  password: <Trans i18nKey="text.password" defaults="Password" />,
  passwordsMustMatch: (
    <Trans i18nKey="text.passwordsMustMatch" defaults="Passwords must match" />
  ),
  pastBooking: <Trans i18nKey="text.pastBooking" defaults="Past booking" />,
  pay: <Trans i18nKey="text.pay" defaults="Pay" />,
  payer: <Trans i18nKey="text.payer" defaults="Payer" />,
  payment: <Trans i18nKey="text.payment" defaults="Payment" />,
  personalTicketsCount: (
    <Trans
      i18nKey="text.personalTicketsCount"
      defaults="
  (1)[{{count}} personal ticket sent];(2-inf)[{{count}} personal tickets sent];"
    />
  ),
  phoneNumber: <Trans i18nKey="text.phoneNumber" defaults="Phone number" />,
  pressHereToSearch: (
    <Trans i18nKey="text.pressHereToSearch" defaults="Press here to search" />
  ),
  priceIsForAllPassengers: (
    <Trans
      i18nKey="text.priceIsForAllPassengers"
      defaults="The price covers all passengers."
    />
  ),
  pricePerPassenger: (
    <Trans i18nKey="text.pricePerPassenger" defaults="Price per passenger " />
  ),
  pricesDisplayedInCurrency: (
    <Trans
      i18nKey="text.pricesDisplayedInCurrency"
      defaults="Prices displayed in {{currency}}"
    />
  ),
  promoCode: <Trans i18nKey="text.promoCode" defaults="Promo code" />,
  purchase: <Trans i18nKey="text.purchase" defaults="Purchase" />,
  readMore: <Trans i18nKey="text.readMore" defaults="Read more" />,
  recipientMustBeChosen: (
    <Trans
      i18nKey="text.recipientMustBeChosen"
      defaults="A recipient for ticket(s) must be chosen."
    />
  ),
  refund: <Trans i18nKey="text.refund" defaults="Refund" />,
  refundFee: <Trans i18nKey="text.refundFee" defaults="Refund fee" />,
  refundInitiated: (
    <Trans
      i18nKey="text.refundInitiated"
      defaults="Trip successfully cancelled. Your refund will be issued in 3 business days."
    />
  ),
  refundIssuedText: (
    <Trans
      i18nKey="text.refundIssuedText"
      defaults="The refund will be issued to the card that was used to pay for the booking."
    />
  ),
  refundTravelPasses: (
    <Trans
      i18nKey="text.refundTravelPasses"
      defaults="(1)[Refund travel pass];(2-inf)[Refund travel passes]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  refundTrips: (
    <Trans
      i18nKey="text.refundTrips"
      defaults="(1)[Refund trip];(2-inf)[Refund trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  refundable: <Trans i18nKey="text.refundable" defaults="Refundable" />,
  refunded: <Trans i18nKey="text.refunded" defaults="Refunded" />,
  remaining: <Trans i18nKey="text.remaining" defaults="Remaining" />,
  remainingUses: (
    <Trans i18nKey="text.remainingUses" defaults="Remaining uses" />
  ),
  remove: <Trans i18nKey="text.remove" defaults="Remove" />,
  revertChanges: (
    <Trans i18nKey="text.revertChanges" defaults="Revert changes" />
  ),
  repeatNewPassword: (
    <Trans i18nKey="text.repeatNewPassword" defaults="Repeat new password" />
  ),
  requiredData: <Trans i18nKey="text.requiredData" defaults="Required data" />,
  requiredField: (
    <Trans i18nKey="text.requiredField" defaults="Required field" />
  ),
  resendConfirmationEmail: (
    <Trans
      i18nKey="text.resendConfirmationEmail"
      defaults="Resend confirmation email"
    />
  ),
  resendTheLinkViaEmail: (
    <Trans
      i18nKey="text.resendTheLinkViaEmail"
      defaults="Resend the link via email"
    />
  ),
  reservedSeats: (
    <Trans i18nKey="text.reservedSeats" defaults="Reserved seats" />
  ),
  resetPassword: (
    <Trans i18nKey="text.resetPassword" defaults="Reset password" />
  ),
  resetYourPassword: (
    <Trans i18nKey="text.resetYourPassword" defaults="Reset your password" />
  ),
  reusableSum: <Trans i18nKey="text.reusableSum" defaults="Reusable sum" />,
  return: <Trans i18nKey="text.return" defaults="Return" />,
  returnTrip: <Trans i18nKey="text.returnTrip" defaults="Return trip" />,
  returnTrips: (
    <Trans
      i18nKey="text.returnTrips"
      defaults="(1)[Return trip];(2-inf)[Return trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  route: <Trans i18nKey="text.route" defaults="Route" />,
  save: <Trans i18nKey="text.save" defaults="Save" />,
  seatMapKey: <Trans i18nKey="text.seatMapKey" defaults="Seat map key" />,
  seatReservationNotAvailable: (
    <Trans
      i18nKey="text.seatReservationNotAvailable"
      defaults="Seat reservation is not available"
    />
  ),
  seatSelection: (
    <Trans i18nKey="text.seatSelection" defaults="Seat selection" />
  ),
  seatSelectionError: (
    <Trans i18nKey="text.seatSelectionError" defaults="Seat not available" />
  ),
  seatSelectionSuccess: (
    <Trans i18nKey="text.seatSelectionSuccess" defaults="Seat selected" />
  ),
  seatTypeUnavailable: (
    <Trans
      i18nKey="text.seatTypeUnavailable"
      defaults="Unavailable seat type"
    />
  ),
  secondsCount: (
    <Trans
      i18nKey="text.secondsCount"
      defaults="(0)[{{count}} seconds];(1)[{{count}} second];(2-inf)[{{count}} seconds];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  select: <Trans i18nKey="text.select" defaults="Select" />,
  selectCountry: (
    <Trans i18nKey="text.selectCountry" defaults="Select country" />
  ),
  selectExtras: <Trans i18nKey="text.selectExtras" defaults="Select extras" />,
  selectGender: <Trans i18nKey="text.selectGender" defaults="Select gender" />,
  selectLanguage: (
    <Trans i18nKey="text.selectLanguage" defaults="Select language" />
  ),
  selectOutboundTicket: (
    <Trans
      i18nKey="text.selectOutboundTicket"
      defaults="Select outbound ticket"
    />
  ),
  selectOutboundTrip: (
    <Trans i18nKey="text.selectOutboundTrip" defaults="Select outbound trip" />
  ),
  selectPassenger: (
    <Trans i18nKey="text.selectPassenger" defaults="Select passenger" />
  ),
  selectPassengersToRefund: (
    <Trans
      i18nKey="text.selectPassengersToRefund"
      defaults="Select passengers to refund"
    />
  ),
  selectReturnTicket: (
    <Trans i18nKey="text.selectReturnTicket" defaults="Select return ticket" />
  ),
  selectReturnTrip: (
    <Trans i18nKey="text.selectReturnTrip" defaults="Select return trip" />
  ),
  selectSeats: <Trans i18nKey="text.selectSeats" defaults="Select seats" />,
  selectTravelPass: (
    <Trans i18nKey="text.selectTravelPass" defaults="Select travel pass" />
  ),
  selected: <Trans i18nKey="text.selected" defaults="Selected" />,
  selectedSeat: <Trans i18nKey="text.selectedSeat" defaults="Selected seat" />,
  send: <Trans i18nKey="text.send" defaults="Send" />,
  sendAllTicketsTo: (
    <Trans
      i18nKey="text.sendAllTicketsTo"
      defaults="Send <strong>all</strong> tickets to"
      components={{ strong: <strong /> }}
    />
  ),
  sendPassengersOwnTicketsTo: (
    <Trans
      i18nKey="text.sendPassengersOwnTicketsTo"
      defaults="
  Send <strong>passenger's own</strong> tickets to"
      components={{ strong: <strong /> }}
    />
  ),
  sendToEmail: <Trans i18nKey="text.sendToEmail" defaults="Send to email" />,
  sendTravelPassTo: (
    <Trans i18nKey="text.sendTravelPassTo" defaults="Send travel pass to" />
  ),
  sessionAboutToExpire: (
    <Trans
      i18nKey="text.sessionAboutToExpire"
      defaults="Session about to expire"
    />
  ),
  showLess: <Trans i18nKey="text.showLess" defaults="Show less" />,
  showMap: <Trans i18nKey="text.showMap" defaults="Show map" />,
  showMore: <Trans i18nKey="text.showMore" defaults="Show more" />,
  signUp: <Trans i18nKey="text.signUp" defaults="Sign up" />,
  stopsCount: (
    <Trans
      i18nKey="text.stopsCount"
      defaults="(0)[{{count}} stops];(1)[{{count}} stop];(2-inf)[{{count}} stops];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  streetName: <Trans i18nKey="text.streetName" defaults="Street name" />,
  thankYou: <Trans i18nKey="text.thankYou" defaults="Thank you!" />,
  tickets: <Trans i18nKey="text.tickets" defaults="Tickets" />,
  ticketsSentSuccessfully: (
    <Trans
      i18nKey="text.ticketsSentSuccessfully"
      defaults="Tickets sent successfully."
    />
  ),
  total: <Trans i18nKey="text.total" defaults="Total" />,
  totalPrice: <Trans i18nKey="text.totalPrice" defaults="Total price" />,
  totalRefund: <Trans i18nKey="text.totalRefund" defaults="Total refund" />,
  totalRefunds: <Trans i18nKey="text.totalRefunds" defaults="Total refunds" />,
  train: <Trans i18nKey="text.train" defaults="Train" />,
  transfer: <Trans i18nKey="text.transfer" defaults="Transfer" />,
  transferTime: <Trans i18nKey="text.transferTime" defaults="transfer time" />,
  transfersCount: (
    <Trans
      i18nKey="text.transfersCount"
      defaults="(0)[{{count}} transfers];(1)[{{count}} transfer];(2-inf)[{{count}} transfers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  travelPass: <Trans i18nKey="text.travelPass" defaults="Travel pass" />,
  travelPassDetails: (
    <Trans i18nKey="text.travelPassDetails" defaults="Travel pass details" />
  ),
  travelPassSentSuccessfully: (
    <Trans
      i18nKey="text.travelPassSentSuccessfully"
      defaults="Travel pass sent successfully"
    />
  ),
  travelPassUsage: (
    <Trans i18nKey="text.travelPassUsage" defaults="Travel pass usage" />
  ),
  travelPasses: <Trans i18nKey="text.travelPasses" defaults="Travel passes" />,
  tripLegPartIndex: (
    <Trans i18nKey="text.tripLegPartIndex" defaults="Part {{tripLegPart}}" />
  ),
  tripNumber: <Trans i18nKey="text.tripNumber" defaults="Trip {{number}}" />,
  unavailable: <Trans i18nKey="text.unavailable" defaults="Unavailable" />,
  unavailableSeat: (
    <Trans i18nKey="text.unavailableSeat" defaults="Unavailable seat" />
  ),
  unchangeable: <Trans i18nKey="text.unchangeable" defaults="Unchangeable" />,
  undefinedConsentDescription: (
    <Trans
      i18nKey="text.undefinedConsentDescription"
      defaults="Undefined consent description"
    />
  ),
  undo: <Trans i18nKey="text.undo" defaults="Undo" />,
  upcoming: <Trans i18nKey="text.upcoming" defaults="Upcoming" />,
  updatingInformationFailed: (
    <Trans
      i18nKey="text.updatingInformationFailed"
      defaults="Updating information failed."
    />
  ),
  used: <Trans i18nKey="text.used" defaults="Used" />,
  validFrom: <Trans i18nKey="text.validFrom" defaults="Valid from" />,
  validTo: <Trans i18nKey="text.validTo" defaults="Valid to" />,
  validUntil: <Trans i18nKey="text.validUntil" defaults="Valid until" />,
  viewBookedTrips: (
    <Trans i18nKey="text.viewBookedTrips" defaults="View booked trips" />
  ),
  viewDetails: <Trans i18nKey="text.viewDetails" defaults="View details" />,
  viewTickets: <Trans i18nKey="text.viewTickets" defaults="View tickets" />,
  voucher: <Trans i18nKey="text.voucher" defaults="Voucher" />,
  voucherCode: <Trans i18nKey="text.voucherCode" defaults="Voucher code" />,
  voucherCodeNotValid: (
    <Trans
      i18nKey="text.voucherCodeNotValid"
      defaults="Voucher code not valid."
    />
  ),
  vouchers: <Trans i18nKey="text.vouchers" defaults="Vouchers" />,
  weHaveSentYouTheLink: (
    <Trans
      i18nKey="text.weHaveSentYouTheLink"
      defaults="We have sent you a link to reset your password. If you haven't received it, please check your spam folder or click on the resend link below."
    />
  ),
  wheelchair: <Trans i18nKey="text.wheelchair" defaults="Wheelchair" />,
  wheelchairAccessible: (
    <Trans
      i18nKey="text.wheelchairAccessible"
      defaults="Wheelchair accessible"
    />
  ),
  willSendYouTheLink: (
    <Trans
      i18nKey="text.willSendYouTheLink"
      defaults="We will send you the link to reset your password via email."
    />
  ),
  youAreAboutToRefundFollowingItems: (
    <Trans
      i18nKey="text.youAreAboutToRefundFollowingItems"
      defaults="You are about to refund the following items:"
    />
  ),
  yourInformationHasBeenUpdated: (
    <Trans
      i18nKey="text.yourInformationHasBeenUpdated"
      defaults="Your information has been updated."
    />
  ),
  yourPaymentIsBeingProcessedPleaseWait: (
    <Trans
      i18nKey="text.yourPaymentIsBeingProcessedPleaseWait"
      defaults="Your payment is being processed. Please wait..."
    />
  ),
});

export type TransTextKeys = TransKeys<typeof TransText>;
